export const convertMarkdownToHTML = (text: string): string => {
	let html = text;

	// Convert <br> tags to actual line breaks so markdown can be parsed properly
	html = html.replace(/<br\s*\/?>/gi, '\n');

	// Headings (allow optional leading spaces)
	html = html.replace(/^\s*###### (.+)$/gm, '<h6 class="text-xs font-bold mt-5">$1</h6>');
	html = html.replace(/^\s*##### (.+)$/gm, '<h5 class="text-sm font-bold mt-5">$1</h5>');
	html = html.replace(/^\s*#### (.+)$/gm, '<h4 class="text-base font-bold mt-5">$1</h4>');
	html = html.replace(/^\s*### (.+)$/gm, '<h3 class="text-lg font-bold mt-5">$1</h3>');
	html = html.replace(/^\s*## (.+)$/gm, '<h2 class="text-xl font-bold mt-5">$1</h2>');
	html = html.replace(/^\s*# (.+)$/gm, '<h1 class="text-2xl font-bold mt-5">$1</h1>');

	// Bold, Italic, Inline Code
	html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
	html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
	html = html.replace(/`([^`]+)`/g, '<code>$1</code>');

	// Links and Images
	html = html.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" />');
	html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>');

	// Blockquote
	html = html.replace(/^\s*> (.+)$/gm, '<blockquote>$1</blockquote>');

	// Horizontal Rule
	html = html.replace(/^\s*---+$/gm, '<hr />');

	// Unordered list items
	html = html.replace(/^\s*\* (.+)$/gm, '<li>$1</li>');

	// Wrap consecutive <li> elements in a <ul>
	html = html.replace(/(<li>.*<\/li>\s*)+/g, match => {
		return `<ul>${match.trim()}</ul>`;
	});

	return html;
};
